// DS: PO27
/** A popup for showing a comments thread */ import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import CommentThread from '../CommentThread';
import Comment from '../Comment/presets/Comment';
import s from './CommentModal.scss';
export const CommentModal = (props)=>{
    const { t } = useTranslation();
    const { typeid, itemid, commentid, parentComment, isInfinite, isOpen, closeAllCommentModals, className } = props;
    const parentCommentRef = /*#__PURE__*/ React.createRef();
    return /*#__PURE__*/ React.createElement(DSModal, {
        heading: `${t('commentmodal.dialogTitle')}:`,
        isFullscreen: true,
        className: classnames(s['root'], s['comment-modal'], className),
        contentClassName: s['content'],
        isOpen: !!isOpen,
        onRequestClose: closeAllCommentModals,
        showHeaderBorder: true
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            is_comment_thread: 1
        }
    }, parentComment && /*#__PURE__*/ React.createElement("div", {
        ref: parentCommentRef
    }, /*#__PURE__*/ React.createElement(Comment, {
        className: s['parent-comment'],
        comment: parentComment
    })), /*#__PURE__*/ React.createElement(CommentThread, {
        className: s['thread'],
        commentableTypeId: typeid,
        commentableItemId: itemid,
        parentId: commentid,
        parentComment: parentComment,
        parentCommentRef: parentCommentRef,
        postbox: "none",
        statsAndControls: "off",
        isInfinite: isInfinite,
        isModal: true
    })));
};
CommentModal.displayName = 'CommentModal';
export default CommentModal;

//# sourceMappingURL=CommentModal.js.map